exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Screener-___table__table___24isB .ant-table{border:none}.src-components-Screener-___table__table___24isB .ant-table-row{height:44px}\n", ""]);

// Exports
exports.locals = {
	"table": "src-components-Screener-___table__table___24isB"
};